export function StarField() {
  return (
    <div className="starfield" aria-hidden="true">
      <div className="stars-layer" />
    </div>
  );
}
